import React from "react";
import { Link } from "react-router-dom";
import useGetLink from "../../../../hooks/other/useGetLink";
import "./providers-item.scss";

export default function ProviderItem({ el }) {
  const providerLink = useGetLink(el.url);

  if (!el) return <></>;

  return (
    <Link className="providers__item" to={providerLink}>
      <div className="providers__item__content">
        <span className="providers__item__text">{el.name}</span>
      </div>
    </Link>
  );
}
